<script setup>
import { useFieldsStore } from "@/stores/storeFieldData";
import { useValidation } from "@/composables/useValidataion";

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	stateKey: {
		type: String,
	},
	responseError: {
		type: Object,
		default: () => ({ active: false, text: "" }),
	},
});
</script>
<template>
	<label :class="['checkbox', isTouched && (isValid ? 'valid' : 'not-valid')]">
		<div class="checkbox__inner">
			<input type="checkbox" class="checkbox__real-input" @change="(storeField.updateFields(stateKey, 'title', value), validation(stateKey))" v-model="value" />
			<span class="checkbox__custom-input"></span>
			<span class="checkbox__text">
				<slot></slot>
			</span>
		</div>
		<Transition mode="out-in">
			<span v-if="!!textError" class="input__error">{{ textError }}</span>
		</Transition>
	</label>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.checkbox {
	display: grid;
	gap: 0.5rem;
}
.checkbox__inner {
	display: flex;
	align-items: start;
	gap: 0.8rem;
}
.checkbox__real-input {
	width: 0;
	height: 0;
	opacity: 0;
	position: absolute;
	z-index: -1;
}

.checkbox__custom-input {
	display: flex;
	align-items: center;
	justify-self: center;
	position: relative;
	border: 1px solid var(--border-accent-2-1);
	border-radius: 0.8rem;
	width: 2.4rem;
	height: 2.4rem;
	flex-shrink: 0;
	background-color: transparent;
	transition: var(--transition) ease-in;
}
.checkbox__text {
	font-weight: 400;
	font-size: 16px;
	line-height: 140%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		font-size: 14px;
	}
	:deep(a) {
		white-space: nowrap;
		color: var(--fill-accent-2-1);
		border-bottom: 0.1rem solid currentColor;
		@media (max-width: vars.$x425) {
			white-space: wrap;
		}
		@media (hover: hover) {
			&:hover {
				color: var(--fill-accent-2-1);
				border-color: transparent;
			}
		}
	}
}

.checkbox__custom-input::before {
	content: "";
	display: inline-block;
	width: 2rem;
	height: 2rem;
	background-image: url("@/assets/img/icons/check.svg");
	background-repeat: no-repeat;
	background-position: center;
	background-size: auto;
	position: absolute;
	transform: scale(0);

	transition: 0.2s ease-in;
	@media (max-width: vars.$x480) {
		// width: 2rem;
		// height: 2rem;
	}
}
.checkbox__real-input:checked + .checkbox__custom-input {
	background: var(--fill-accent-2-1);
}
.checkbox__real-input:checked + .checkbox__custom-input::before {
	transform: scale(1) translateX(1.5px);
}
.v-enter-active,
.v-leave-active {
	transition: all 0.25s ease-out;
}

.v-enter-from {
	opacity: 0;
	transform: translateX(20px);
}
.v-leave-to {
	opacity: 0;
	transform: translateX(-20px);
}
</style>
@/stores/storeFieldData
